export default __webpack_public_path__ + "static/media/bg_groupement_pres-1.33f5c78d.jpg";